import App from '@app/App';
import { store } from '@mgStore/store';
import { JourneyBuilderProvider } from '@opap/jbca-postmonger-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const { worker } = await import('./mocks/browser');

  return worker.start();
}

const query = new QueryClient();

enableMocking()
  .then(() => {
    const root = createRoot(document.querySelector('#root') as HTMLElement);
    root.render(
      <StrictMode>
        <JourneyBuilderProvider>
          <Provider store={store}>
            <QueryClientProvider client={query}>
              <App />
            </QueryClientProvider>
          </Provider>
        </JourneyBuilderProvider>
      </StrictMode>
    );
  })
  .catch(error => {
    console.error('Error rendering application:', error);
  });
